import ACTIONS from "../../constants/actions";
import Xhr from "../../helpers/Xhr";
import {getCash} from "./user";
import {toggleProcessing} from "./oneclick";

export const getCoupon = (type) => dispatch => {
	Xhr.getCoupon(type).then((resp) => dispatch({
		type     : ACTIONS.COUPON.UPDATE,
		data     : resp.data,
		fetching : false
	}));
};

export const getCouponLine = (type) => dispatch => {
	Xhr.getCouponLine(type).then((resp) => dispatch({
		type     : ACTIONS.COUPON.UPDATE,
		data     : resp.data,
		fetching : false
	}));
};

export const addToCoupon = (eventId, hash) => dispatch => {
	Xhr.couponAdd(eventId, hash).then((resp) => dispatch({
		type : ACTIONS.COUPON.UPDATE,
		data : resp.data
	}));
};

export const addToCouponAndMakeBet = (eventId, hash, type, data) => dispatch => {
	dispatch(toggleProcessing(true));

	Xhr.couponAdd(eventId, hash).then((resp) => {
		dispatch({
			type : ACTIONS.COUPON.UPDATE,
			data : resp.data
		});

		dispatch(makeBet(type, data));
	});
};

export const nextCoupon = (type) => dispatch => {
	Xhr.couponNext(type).then((resp) => dispatch({
		type : ACTIONS.COUPON.UPDATE,
		data : resp.data
	}));
};

export const prevCoupon = (type) => dispatch => {
	Xhr.couponPrev(type).then((resp) => dispatch({
		type : ACTIONS.COUPON.UPDATE,
		data : resp.data
	}));
};

export const clearCoupon = (type) => dispatch => {
	Xhr.couponClear(type).then((resp) => {
			if ( resp.status === 'ok' ) {
				dispatch({
					type : ACTIONS.COUPON.UPDATE,
					data : {}
				});
			}
		}
	);
};

export const delCoupon = (type, eventId) => dispatch => {
	Xhr.couponDel(type, eventId).then((resp) => dispatch({
		type : ACTIONS.COUPON.UPDATE,
		data : resp.data
	}));
};

export const setGoldbet = (gold, type, system = 0) => dispatch => {
	Xhr.setGoldBet(gold, type, system = 0).then((resp) => dispatch({
		type : ACTIONS.COUPON.UPDATE,
		data : resp.data
	}));
};

export const setLiveOpt = (option) => dispatch => {
	Xhr.setLiveOpt(option).then((resp) => dispatch({
		type : ACTIONS.COUPON.CHANGE_LIVE_OPT,
		data : resp.data
	}));
};

export const makeBet = (type, data) => dispatch => {
	Xhr.makeBet(type, data).then((resp) => {
		dispatch({
			type : ACTIONS.COUPON.UPDATE,
			data : resp.data
		});

		// обновляем бабло
		dispatch(getCash());

		// останавливаем процесс для ставки в один клик (если это ставка в один клик)
		dispatch(toggleProcessing(false));
	});
};

export const makeLineBet = (data) => dispatch => {
	Xhr.makeLineBet(data).then((resp) => {
		if ( resp.data.hasOwnProperty('messages') ) {
			alert(resp.data.messages);
		}

		dispatch({
			type : ACTIONS.COUPON.UPDATE,
			data : resp.data
		});

		dispatch(getCash());
	});
};


// WEBPACK FOOTER //
// ./src/app/redux/actions/coupon.js